import {StyleParamType, createStylesParams} from '@wix/tpa-settings'

import {Alignment} from '../../../../../../types/createStylesParams'
import {ALIGNMENT_DESCRIPTION, numberEnumMetadata} from '../../../../../../utils/builderMetadata'

export type AboutSectionStylesParams = {
  aboutSectionAlignment: StyleParamType.Number
}

export const aboutSectionStylesParams = createStylesParams<AboutSectionStylesParams>({
  aboutSectionAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Left,
    metadata: numberEnumMetadata({defaultValue: Alignment.Left}, ALIGNMENT_DESCRIPTION),
  },
})
